import { BarPlot } from '@mui/x-charts/BarChart';
import { ChartsGrid } from '@mui/x-charts/ChartsGrid';
import { ChartsReferenceLine } from '@mui/x-charts/ChartsReferenceLine';
import { ChartsTooltipContainer } from '@mui/x-charts/ChartsTooltip';
import { ChartsXAxis } from '@mui/x-charts/ChartsXAxis';
import { ChartsYAxis } from '@mui/x-charts/ChartsYAxis';
import { ChartsContainer } from '@mui/x-charts/ChartsContainer';
import { formatNumberAbbreviated } from '../../../../../utils/number';
import {
  REPORT_CHART_AXIS_HIDE_SX,
  REPORT_CHART_AXIS_LABEL_STYLE,
  REPORT_CHART_COLORS,
  REPORT_CHART_TICK_LABEL_STYLE,
} from '../../../reports-components/chart-theme';
import { CustomerRevenueReportChartTooltip } from './CustomerRevenueReportChartTooltip';
import type { CustomerRevenueChartDataPoint } from './customer-revenue-chart-aggregation';

type BreakdownChartSeries = {
  id: string;
  type: 'bar';
  yAxisId: 'revenue';
  data: number[];
  label: string;
  color: string;
};

type CustomerRevenueReportBreakdownChartProps = {
  data: CustomerRevenueChartDataPoint[];
};

export const CustomerRevenueReportBreakdownChart: React.FC<CustomerRevenueReportBreakdownChartProps> = ({
  data,
}) => {
  const labels = data.map((point) => point.label);
  const series: BreakdownChartSeries[] = [
    {
      id: 'recognized',
      type: 'bar',
      yAxisId: 'revenue',
      data: data.map((point) => point.recognized),
      label: 'Recognized',
      color: REPORT_CHART_COLORS.recognized,
    },
    {
      id: 'deferred',
      type: 'bar',
      yAxisId: 'revenue',
      data: data.map((point) => point.deferred),
      label: 'Deferred',
      color: REPORT_CHART_COLORS.deferred,
    },
    {
      id: 'unbilled',
      type: 'bar',
      yAxisId: 'revenue',
      data: data.map((point) => point.unbilled),
      label: 'Unbilled',
      color: REPORT_CHART_COLORS.unbilled,
    },
  ];

  return (
    <ChartsContainer
      height={220}
      margin={{ left: 65, top: 10, right: 20, bottom: 30 }}
      sx={REPORT_CHART_AXIS_HIDE_SX}
      xAxis={[
        {
          id: 'months',
          scaleType: 'band',
          data: labels,
          tickLabelStyle: REPORT_CHART_TICK_LABEL_STYLE,
        },
      ]}
      yAxis={[
        {
          id: 'revenue',
          valueFormatter: (value: number) => formatNumberAbbreviated(value),
          tickLabelStyle: REPORT_CHART_AXIS_LABEL_STYLE,
        },
      ]}
      series={series}
    >
      <ChartsGrid horizontal />
      <BarPlot borderRadius={4} />
      <ChartsReferenceLine y={0} lineStyle={{ stroke: '#CBD5E0', strokeWidth: 1 }} />
      <ChartsXAxis axisId="months" tickSize={0} />
      <ChartsYAxis axisId="revenue" />
      <ChartsTooltipContainer trigger="axis">
        <CustomerRevenueReportChartTooltip />
      </ChartsTooltipContainer>
    </ChartsContainer>
  );
};
